










































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import { BrandDto, BrandListDto, FoodCategoryDto } from '../../../dto';
import BrandService from '../../../services/brand.service';
import FoodCategoryService from '../../../services/food-category.service';
import { Pagination, YN, CONST_YN } from '@/common';
import CodeManagementService from '../../../services/code-management.service';
import { FileAttachmentDto } from '@/services/shared/file-upload';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';
import { ATTACHMENT_REASON_TYPE } from '@/services/shared/file-upload';

import toast from '../../../../resources/assets/js/services/toast.js';
import { CodeManagementDto } from '@/services/init/dto';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';
import { BRAND_TYPE } from '@/services/shared';

@Component({
  name: 'BrandList',
})
export default class BrandList extends BaseComponent {
  constructor() {
    super();
  }
  private brandList: BrandDto[] = [];
  private brandTotalCount = null;
  private brandSearchDto = new BrandListDto();
  private pagination = new Pagination();
  private ynSelect: YN[] = [...CONST_YN];
  private foodCategorySelect: FoodCategoryDto[] = [];
  private dataLoading = false;
  private storeCountValues: CodeManagementDto[] = [];
  private costValues: CodeManagementDto[] = [];
  private difficultyValues: CodeManagementDto[] = [];
  private brandCreateDto = new BrandDto();
  private brandLogo: FileAttachmentDto[] = [];
  private brandType: CodeManagementDto[] = [];
  private searchQueryParamsDto: any = {};

  // search brand
  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1; // 최초 페이지 진입시 페이지 초기화
    } else {
      if (isSearch) this.pagination.page = 1; // 검색버튼 클릭시 페이지 초기화
      RouterQueryParamMapper(this.brandSearchDto, this.pagination);
    }
    BrandService.findAll(this.brandSearchDto, this.pagination).subscribe(
      res => {
        if (res) {
          this.dataLoading = false;
          this.brandList = res.data.items;
          this.brandTotalCount = res.data.totalCount;
        }
      },
    );
  }

  // pagination
  paginateSearch() {
    this.findAll(true);
  }

  // serach
  search() {
    this.findAll(true, true);
  }

  // get food category
  getFoodCategories() {
    FoodCategoryService.findForSelect().subscribe(res => {
      this.foodCategorySelect = res.data;
    });
  }

  // clear brand search dto
  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.brandSearchDto = new BrandListDto();
      this.findAll();
    }
  }

  // create brand
  createBrand() {
    if (this.brandLogo) {
      this.brandCreateDto.logo = this.brandLogo;
    }

    BrandService.create(this.brandCreateDto).subscribe(res => {
      if (res) {
        toast.success('추가완료');
        this.clearOut();
      }
    });
  }

  // upload brand logo
  async upload(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(
        UPLOAD_TYPE.BRAND_LOGO,
        [file],
      );
      this.brandLogo = [];
      this.brandLogo.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
    }
  }

  // clear brand craete dto
  clearOutBrandCreateDto() {
    this.brandLogo = [];
    this.brandCreateDto = new BrandDto();
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.brandSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }

    this.getCommonCodes('costValues', 'BRAND');
    this.getCommonCodes('storeCountValues', 'STORE_COUNT');
    this.getCommonCodes('difficultyValues', 'DIFFICULTY');
    this.getCommonCodes('brandType', 'BRAND_TYPE');
    this.getFoodCategories();
  }
}
